import React from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignPriceOffer } from '../../types/contract';
import styles from './styles/Accordion.module.scss';

type AccordionProps = {
  className?: string;
  open?: boolean;
  title: string | React.JSX.Element;
  children: React.JSX.Element | React.JSX.Element[];
  icon?: boolean;
  offer?: CampaignPriceOffer;
  onClick?: React.MouseEventHandler;
};

const Accordion: React.FunctionComponent<AccordionProps> = (props: AccordionProps) => {
  const { t } = useTranslation();
  const { className, open, title, children, icon, offer, onClick } = props;

  return (
    <details className={`${styles.accordion} ${className ? styles[className] : ''}`} open={open} onClick={onClick}>
      <summary className={icon ? styles.icon : ''}>
        <div>
          {title}

          {offer && (
            <div className={styles.contractOffer}>
              <div>
                {offer.renewalOffer === true && t('header:navigation.newOffer')}
                <span>{t('header:navigation.checkOffer')}</span>
              </div>
            </div>
          )}
        </div>
        <span className={styles.arrow} />
      </summary>
      <div className={styles.contents}>{children}</div>
    </details>
  );
};

export default Accordion;
